import { Box } from "@chakra-ui/react";
import Footer from 'component/header/Footer'
import Success from 'component/home/component/Success'
import useScrollAnimation from "component/useScrollAnimation";
import React from 'react'
import Newportfolio from "./Newportfolio";

const PortFolio = () => {
  useScrollAnimation()
  return (
    <>
    <Box bg="#D7D7D7" >
        <Box bg="#F4EDDC" pt={16} >
      <Newportfolio />
      </Box>
      <Success/>
      </Box>
      <Footer/>
      
    </>
  )
}

export default PortFolio
